import React from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListSubheader from "@material-ui/core/ListSubheader";
import styled from "styled-components";

interface SectionMaterialProps {
    title?: string;
    disableGutters?: boolean;
    children: any;
}

const ListHeaderContainer = styled(ListSubheader)`
  font-size: 1.10rem;
  margin-top: 0;
  margin-bottom: 0;
`;

const ListHeaderText = styled.p`
  font-size: 1.10rem;
  margin-top: 0;
  margin-bottom: 0;
`;

const ListContentContainer = styled(List)`
  width: 100%;
  padding-top: 0 !important;
`;

const ListItemContainer = styled(ListItem)`
  padding-top: 0 !important;
`;

const SectionView = (props: SectionMaterialProps) => {
    const {title, disableGutters} = props;
    return (
        <ListItemContainer
            disableGutters={disableGutters || false}
            button={false}
        >
                <ListContentContainer
                    subheader={
                    <ListHeaderContainer
                        disableSticky={true}
                        disableGutters
                    >
                        {title &&
                        <ListHeaderText>
                            {title}
                        </ListHeaderText>
                        }
                    </ListHeaderContainer>
                    }
                >
                    {props.children}
                </ListContentContainer>
        </ListItemContainer>
    );
};

SectionView.defaultProps = {
    direction: 'vertical',
    disableGutters: false,
    text: "",
};

export default SectionView;